<template>
  <div class="orderDetail fuwudetail">
    <div class="hed">
      <span class="number">订单号码：{{ msgNo }}</span>
      <span class="status">{{ dealStatus.label }}</span>
    </div>
    <div class="ordercon">
      <div class="title1" v-if="dealStatus.value == '1'">
        <div class="status2">
          <div class="con1">
            <span>已处理</span>
          </div>
        </div>
      </div>
      <div class="title1" v-if="dealStatus.value == '2'">
        <div class="status2">
          <div class="con1">
            <span>请耐心等待工作人员处理</span>
          </div>
        </div>
      </div>
      <div class="title1" v-if="dealStatus.value == '3'">
        <div class="status2">
          <div class="con1">
            <span>已撤回</span>
          </div>
        </div>
      </div>
      <div class="content">
        <div v-if="pageName == 'forward'" class="shop">
          <div class="info">
            <span class="name">提交时间：{{ forward.createDate }}</span>
            <span class="name">预约时间：{{ $substr(forward.predate, 0, 10) }}</span>
            <span class="name">同行人数：{{ forward.userCount }}人</span> <br />
            <span class="name">预约人姓名：{{ forward.userName }}</span>
            <span class="name">预约人手机号：{{ forward.mobile }}</span>
            <span class="name">预约人身份证：{{ forward.idCard }}</span>
          </div>
          <img src="../../../assets/li.svg" class="line" />
        </div>
        <div v-if="pageName == 'tomb'" class="shop">
          <div class="info">
            <span class="name">预约时间 {{ $substr(tomb.predate, 0, 10) }}</span>
            <span class="name">预约人姓名：{{ tomb.userName }}</span>
            <span class="name">预约人手机号：{{ tomb.mobile }}</span>
            <span class="name">备注：{{ tomb.userMemo }}</span>
            <span class="name">提交时间：{{ tomb.createDate }}</span>
          </div>
          <img src="../../../assets/li.svg" class="line" />
        </div>
        <div v-if="pageName == 'repair'" class="shop">
          <div class="info">
            <span class="name">提交时间：{{ repair.createDate }}</span>
            <span class="name">墓地编号：{{ repair.repairNo }}</span> <br />
            <span class="name">说明：{{ repair.content }}</span>
            <!-- <img src="../../../assets/shop.jpg" class="pic2" /> -->
            <div>
              <template v-for="(item, nn) in repair.gallery">
                <img
                  :key="nn"
                  :src="item"
                  alt="图片"
                  class="imgPreview"
                  style="width:80px;height:80px;float:left;"
                />
              </template>
            </div>
          </div>
          <img src="../../../assets/li.svg" class="line" />
        </div>
      </div>

      <div class="ma" v-if="dealStatus.value == '1'">
        <span class="ordertime"
          >管理员反馈:&nbsp;&nbsp;
          <span v-if="dealResult">{{ dealResult }}</span>
          <span v-else>无</span>
        </span>
      </div>
    </div>
    <div class="bottom" v-if="dealStatus.value == '2'">
      <ul>
        <li>
          <div class="delete" @click="submitStatus()">撤回申请</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cart',
  data() {
    return {
      msgNo: null,
      dealStatus: {},
      dealResult: null,
      createDate: null,
      pageName: '',
      id: 0,
      forward: {
        id: 0,
        msgNo: null,
        predate: null,
        mobile: null,
        idCard: null,
        userName: null,
        userCount: null,
        dealStatus: null,
        dealDate: null,
        dealResult: null,
        createDate: null,
      },
      tomb: {
        id: null,
        msgNo: null,
        predate: null,
        mobile: null,
        idCard: null,
        userName: null,
        userCount: null,
        userMemo: null,
        dealStatus: null,
        dealDate: null,
        dealResult: null,
        createDate: null,
      },
      repair: {
        id: null,
        msgNo: null,
        repairNo: null,
        content: null,
        dealStatus: null,
        dealDate: null,
        dealResult: null,
        createDate: null,
        gallery: [],
      },
    }
  },
  created() {
    this.pageName = this.$route.params.type
    console.log(this.pageName)
  },
  mounted() {
    this.pageName = this.$route.params.type
    this.id = this.$route.params.id
    if (this.pageName == 'forward') {
      this.queryForwardOne(this.id)
    } else if (this.pageName == 'tomb') {
      this.queryTombOne(this.id)
    } else if (this.pageName == 'repair') {
      this.queryRepairOne(this.id)
    }
  },
  methods: {
    goto(str) {
      this.$router.push({ path: str })
    },
    queryForwardOne(id) {
      var that = this
      this.$queryOne(
        'MsgForward',
        { id: id },
        [
          'id',
          'msgNo',
          'predate',
          'mobile',
          'idCard',
          'userName',
          'userCount',
          'dealStatus',
          'dealDate',
          'dealResult',
          'createDate',
        ],
        function(res) {
          that.$fill(that.forward, res['data'])
          that.msgNo = that.forward.msgNo
          that.dealStatus = that.forward.dealStatus
          that.dealResult = that.repair.dealResult
          that.createDate = that.repair.createDate
        }
      )
    },
    queryTombOne(id) {
      var that = this
      this.$queryOne(
        'MsgTomb',
        { id: id },
        [
          'id',
          'msgNo',
          'predate',
          'mobile',
          'userName',
          'userMemo',
          'dealStatus',
          'dealDate',
          'dealResult',
          'createDate',
        ],
        function(res) {
          that.$fill(that.tomb, res['data'])
          that.msgNo = that.tomb.msgNo
          that.dealStatus = that.tomb.dealStatus
          that.dealResult = that.tomb.dealResult
          that.createDate = that.tomb.createDate
        }
      )
    },
    queryRepairOne(id) {
      var that = this
      this.$queryOne(
        'MsgRepair',
        { id: id },
        [
          'id',
          'msgNo',
          'repairNo',
          'content',
          'dealStatus',
          'dealDate',
          'dealResult',
          'gallery',
          'createDate',
          'gallery',
        ],
        function(res) {
          that.$fill(that.repair, res['data'])
          that.msgNo = that.repair.msgNo
          that.dealStatus = that.repair.dealStatus
          that.dealResult = that.repair.dealResult
          that.createDate = that.repair.createDate
        }
      )
    },
    submitStatus() {
      var that = this
      var entity = null
      var path = ''
      if (this.pageName == 'forward') {
        entity = 'MsgForward'
        path = '/shop/fuwu/forward'
      } else if (this.pageName == 'tomb') {
        entity = 'MsgTomb'
        path = '/shop/fuwu/tomb'
      } else if (this.pageName == 'repair') {
        entity = 'MsgRepair'
        path = '/shop/fuwu/repair'
      }
      this.$submit(
        entity,
        {
          id: this.id,
          dealStatus: 0,
        },
        function(res) {
          if (res['code'] === 1) {
            that.$router.push({ path: path })
          }
        }
      )
    },
  },
}
</script>

<style>
.fuwudetail .shop {
  width: 35.5rem;
  height: 19rem;
  margin: 0.5rem 0 1rem;
}

.fuwudetail .shop .info {
  width: 32.6rem;
  height: 18.7rem;
  position: relative;

  display: flex;
  flex-direction: column;
  margin: 0 auto;
  padding-top: 0.8rem;
}
.fuwudetail .shop .info .name {
  font-size: 1.4rem;
  display: block;
  line-height: 2.5rem;
}
.orderDetail .bottom {
  height: 4.9rem;
  background-color: #fff;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 5rem;
  z-index: 999;
  border: 0.1rem solid #eee;
}
.orderDetail .bottom ul li {
  margin-top: 1rem;
}
.orderDetail .bottom ul li .pay {
  background-color: #15a892;
  color: #fff;
  float: right;
}

.orderDetail .bottom ul li div {
  width: 8rem;
  height: 3rem;
  border: 0.1rem solid #eee;
  font-size: 1.3rem;
  list-style: none;
  float: left;
  margin-right: 1rem;
  padding-top: 0.6rem;
  text-align: center;
}
.orderDetail .bottom ul li .pay {
  background-color: #15a892;
  color: #fff;
  float: right;
}
.orderDetail .bottom ul li .delete {
  color: #999;
  float: right;
}
.orderDetail .hed span {
  font-size: 1.4rem;
}
.orderDetail .hed .status {
  float: right;
  position: relative;
  right: 1.5rem;
  color: #15a892;
}
.orderDetail .hed {
  width: 100%;
  height: 4.6rem;
  background-color: #fff;
  font-size: 1.4rem;
  padding-left: 2rem;
  letter-spacing: 0.1rem;
  padding-top: 1.3rem;
}
.orderDetail .ordercon {
  margin-top: -2rem;
  padding: 0 1rem;
  background: #f3f3f3;
  height: 10rem;
}

.orderDetail .ordercon .title1 {
  width: 100%;
  font-size: 1.3rem;
}
.orderDetail .status2 {
  width: 100%;
  margin-top: 3rem;
  /* padding: 0 1rem; */
  letter-spacing: 0.1rem;
}
.orderDetail .status2 .con1 {
  width: 100%;
  text-align: center;
  padding: 1.9rem 2rem;
  font-size: 1.6rem;
  line-height: 2.5rem;
  background-color: #15a892;
}
.orderDetail .status2 .con1 .cha,
.orderDetail .status2 .con1 .svg11 {
  width: 1.5rem;
  height: 1.5rem;
  position: relative;
  top: 0.2rem;
}
.orderDetail .status2 .con1 p,
.orderDetail .status2 .con1 span {
  color: #fff;
}
.orderDetail .status2 .con1 p,
.orderDetail .status2 .con1 span {
  color: #fff;
}
.orderDetail .status2 p {
  font-size: 1.4rem;
  margin-top: 0.5rem;
}
.orderDetail .condiv {
  padding: 0 1.5rem 0.2rem;
  background-color: #fff;
}
.orderDetail .condiv .title {
  padding: 1.3rem 0;
  line-height: 2rem;
}

.orderDetail .ordercon .content {
  margin-top: 3rem;
  background-color: #fff;
}
.orderDetail .ordercon .content section {
  height: 10rem;
  padding: 1rem;
  box-sizing: border-box;
  font-size: 1.4rem;
  display: flex;
  border-bottom: 1px solid #eee;
}
.orderDetail .ordercon .content section .img img {
  width: 8rem;
  height: 8rem;
  margin-right: 1.3rem;
}
.orderDetail .ordercon .content section .text {
  width: 100%;
}
.orderDetail .ordercon .content section .text .title {
  height: 3.7rem;
  line-height: 2rem;
  overflow: hidden;
}
.orderDetail .ordercon .content section .text .ms {
  height: 1.7rem;
  font-size: 1.2rem;
  color: #999;
}
.orderDetail .ordercon .content section .text .amount {
  display: flex;
  justify-content: space-between;
  line-height: 2.2rem;
}
.orderDetail .ordercon .content section .text .amount .price {
  font-size: 1.6rem;
  color: #15a892;
  padding-top: 0.4rem;
  font-weight: bolder;
}
.orderDetail .ma {
  height: 6rem;
  font-size: 1.4rem;
}
.orderDetail .order-remark,
.orderDetail .ma {
  background: #fff;
  left: 0;
  right: 0;
  padding: 0.5rem 1rem;
  margin-top: 1rem;
  margin-bottom: 6rem;
  width: 100%;
}
.orderDetail .ma .ordertime {
  color: #999;
}
.orderDetail .ma .ordertime {
  color: #999;
}

.orderDetail .ma p {
  margin-top: 1rem;
}
.orderDetail .clear-both {
  clear: both;
  height: 5rem;
}
.orderDetail .foot {
  background: #fff;
  position: fixed;
  z-index: 100;
  left: 0;
  right: 0;
  bottom: 0;
  font-size: 1.4rem;
  width: 100%;
  height: 5rem;
  line-height: 5rem;
  display: flex;
  justify-content: flex-end;
}
.orderDetail .foot .price {
  margin: 0 1.7rem 0 0;
}
.orderDetail .foot .price i {
  color: #15a892;
  font-weight: bolder;
}
.orderDetail .foot .goto {
  background: #15a892;
  color: #fff;
  width: 13.5rem;
  text-align: center;
}
.orderDetail .success {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  visibility: hidden;
  opacity: 0;
  transition: all 1s ease;
  border: 1px solid #eee;
  width: 22rem;
  padding: 3rem 1rem;
  font-size: 1.4rem;
  border-radius: 0.5rem;
  text-align: center;
  background: #fff;
  box-shadow: 1px 2px 5px rgb(0 0 0 / 20%);
}
.orderDetail .success .title {
  color: #15a892;
}
.orderDetail .success .title:before {
  width: 5.5rem;
  height: 5.5rem;
  margin: 0 auto 1rem;
  display: block;
  content: '';
  /* background: url() no-repeat 50%; */
  background-size: contain;
}
.orderDetail .success .text {
  color: #999;
  line-height: 2.4rem;
  margin-top: 2.4rem;
  display: block;
}
</style>
